export type ColumnDef = {
  key: string
  label: string
  format: 'number' | 'currency' | 'percent' | 'raw'
  width: string
}

export const AVAILABLE_COLUMNS: ColumnDef[] = [
  { key: 'status', label: 'Status', format: 'raw', width: '110px' },
  { key: 'campaign', label: 'Campaign', format: 'raw', width: '200px' },
  { key: 'adset', label: 'Ad Set', format: 'raw', width: '180px' },
  { key: 'impressions', label: 'Impressions', format: 'number', width: '130px' },
  { key: 'reach', label: 'Reach', format: 'number', width: '110px' },
  { key: 'clicks', label: 'Clicks', format: 'number', width: '100px' },
  { key: 'ctr', label: 'CTR', format: 'percent', width: '90px' },
  { key: 'cpc', label: 'CPC', format: 'currency', width: '90px' },
  { key: 'cpm', label: 'CPM', format: 'currency', width: '90px' },
  { key: 'spend', label: 'Spend', format: 'currency', width: '100px' },
  { key: 'frequency', label: 'Frequency', format: 'raw', width: '110px' },
  { key: 'unique_clicks', label: 'Unique Clicks', format: 'number', width: '140px' },
  { key: 'social_spend', label: 'Social Spend', format: 'currency', width: '130px' },
  { key: 'video_avg_time_watched_actions', label: 'Avg Watch Time', format: 'raw', width: '150px' },
  { key: 'video_p25_watched_actions', label: 'Video 25%', format: 'raw', width: '110px' },
  { key: 'video_p50_watched_actions', label: 'Video 50%', format: 'raw', width: '110px' },
  { key: 'video_p75_watched_actions', label: 'Video 75%', format: 'raw', width: '110px' },
  { key: 'video_p100_watched_actions', label: 'Video 100%', format: 'raw', width: '120px' },
  { key: 'cost_per_action_type', label: 'Cost/Action', format: 'raw', width: '140px' },
  { key: 'actions', label: 'Actions', format: 'raw', width: '100px' },
  { key: 'created_at', label: 'Created', format: 'raw', width: '130px' },
]

export const DEFAULT_COLUMNS = [
  'status',
  'campaign',
  'adset',
  'impressions',
  'reach',
  'clicks',
  'ctr',
  'spend',
  'frequency',
  'created_at',
]
